import callAPiBase from './base';

const userIpsApi = {
  get: ({ params }: { params?: object }) =>
    callAPiBase({
      endpoint: '/userIpList',
      method: 'GET',
      useToken: true,
      title: 'User Ip - Get List',
      params,
    }),
  create: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/userIpCreate',
      method: 'POST',
      useToken: true,
      title: 'User Ip - Create',
      data,
    }),
  update: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/userIpUpdate',
      method: 'PUT',
      useToken: true,
      title: 'User Ip - Update',
      data,
    }),
  delete: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/userIpDelete',
      method: 'DELETE',
      useToken: true,
      title: 'User Ip - Delete',
      params,
    }),
};

export { userIpsApi };
export default userIpsApi;
